import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const BottomSheetSlideHTML: FC = () => {
  // let templateWidth = useSelector(
  //   (state: RootState) => state.template.templateWidth
  // );
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  // let currentUser = useSelector((state: RootState) => state.client.userCompany);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiTitleURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleURL = getFontURL(fontFamily?.multi_sub_title);
  const multiLeftButtonURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_title}`;
  // const multiSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_sub_title}`;
  // const multiLeftButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleURL});
    }

  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleURL});
    }
  
  @font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonURL});
    }


  @font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonURL});
    }
    
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0,${displayValue});
    }
    .modal_wrapper {
      width: 100%;
      height: 20.5rem;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
      background-color: transparent;
      z-index: 0;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      height: 16rem;
      outline: none;
    }
    .slick-track {
      display: flex;
    }
    .slick-track img {
      object-fit: cover;
    }
    .slick_page {
      padding: 0.25rem 1rem;
      position: absolute;
      top: 1rem;
      right: 1rem;

      display: flex;
      gap: 0.25rem;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .contents_wrapper {
      width: 100%;
      margin-top: 1.5rem;
      padding: 0 7%;

      position: absolute;
      top: 0;
      z-index: 1;
    }
    .contents_box .title {
      width: 100%;
      min-height: 48px;
      margin-bottom: 12px;

      display: flex;
      align-items: center;
    }
    .contents_box .title .title_inner {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 100%;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;
      max-height: 50px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .slick-slider {
      position: relative;
    }
    .slick-dots {
      position: absolute;
      bottom: 1rem;
    }
    .slick-dots li {
      width: 4px;
      height: 4px;
      margin: 0 0.5rem;
    }
    .slick-dots li button {
      width: 4px;
      height: 4px;
      padding: 0;
      border-radius: 4px;
      background: black;
      opacity: 0.3;
    }
    .slick-dots .slick-active button {
      opacity: 1;
    }
    .slick-dots li button::before {
      width: 4px;
      height: 4px;
      padding: 0;
      display: none;
    }

    .btn_wrapper {
      width: 100%;
      height: 4.5rem;
      padding: 1rem 10%;
      padding-bottom: 1.5rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      background-color: #fff;
    }
    .btn_wrapper button {
      border: 0;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: left;
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    /*
    .bottom_wrapper {
      position: absolute;
      left: 10%;
      bottom: 6.75rem;
    }
    .bottom_wrapper button {
      width: 5.5rem;
      height: 2rem;

      display: flex;
      justify-content: center;
      align-items: center;

      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${btnFontFamily?.multi_button};

      border: 0;
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }
    */

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .modal_wrapper {
        height: 36.5rem;
      }
      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list,
      .slick_wrapper .slick-track div,
      .slick_wrapper .slick-track img {
        height: 30rem;
      }
      .slick_page {
        top: 2.5rem;
        right: 2.5rem;
      }

      .contents_wrapper {
        margin-top: 0;
        padding: 3rem;
      }
      .contents_box .title {
        font-size: ${fontSize?.multi_title + 0.75}rem;
      }
      .contents_box .sub_title {
        height: 3rem;
        font-size: ${fontSize?.multi_sub_title + 0.5}rem;
      }
      .contents_box .sub_title_inner {
        max-height: 3rem;
      }

      .btn_wrapper {
        height: 6.5rem;
        padding: 2rem;
        padding-top: 1.5rem;
      }
      .style01 {
        font-size: ${btnFontSize?.multi_left_button + 0.5}rem;
      }
      .style02 {
        font-size: ${btnFontSize?.multi_right_button + 0.5}rem;
      }
    }
  `;

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `
        <div>
          <img
            class="image"
            src="${bgImage?.multi_image[idx]}"
            alt="half top image"
          />
        </div>
            `
            )
            .join('')}
          </div>
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">${text?.multi_title
            ?.map(
              (data: any, idx: number) => `
        <div class="contents_box">
          <div class="title"><div class="title_inner">${changeEnterHTML(
            text?.multi_title?.[idx]
          )}</div></div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.multi_sub_title?.[idx])}
            </div>
          </div>
        </div>`
            )
            .join('')}
          </div>
        </div>
        <div class="btn_wrapper">
          <button class="style01">
            ${btnText?.multi_left_button?.[currentIndex]}
          </button>
          <button class="style02">
            ${btnText?.multi_right_button?.[currentIndex]}
          </button>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = '[';
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_left_button?.length; i++) {
    button_list += `['${btnText?.multi_left_button?.[i]}', '${btnText?.multi_right_button?.[i]}']`;
    if (i !== btnText?.multi_left_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_left_button?.[i]}', '${tracking?.multi_right_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'BOTTOM SHEET SLIDE',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.slick_slider').slick({
      arrows: false,
      infinite: true,
      dots: true,
  
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      touchThreshold: 300
    });

    $('.contents_slider').slick({
      arrows: false,
      infinite: true,
      fade: true,
      swipe: false,
  
      speed: 300,
      touchThreshold: 300
    });

    let currentIndex = 0;
    let button = ${button_list};
    
    $('.style01').text(button[currentIndex][0]);
    $('.style02').text(button[currentIndex][1]);
    $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.slick_slider').slick('slickCurrentSlide');
      $('.contents_slider').slick('goTo', currentIndex);
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
    });
    $('.contents_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.contents_slider').slick('slickCurrentSlide');
      $('.slick_slider').slick('goTo', currentIndex);
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
    });

    let deeplink = ${deeplink_list};
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.image').click(function() {
      appboyBridge.logClick(tracking[currentIndex][0]);
      try {
        if (button1[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.style01').click(function() {
      appboyBridge.logClick(tracking[currentIndex][1]);
      try {
        if (button1[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.style02').click(function() {
      appboyBridge.logClick(tracking[currentIndex][2]);
      try {
        if (button1[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css"
        />
        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        {/* jquery */}
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default BottomSheetSlideHTML;
